class Dispatcher extends Flux.Dispatcher

  dispatch: (options) ->
    super options

module.exports = new Dispatcher()
